import React, { useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import IsLoadingHOC from "../Config/common/Loader/Loader";
import { loginAction, changePassword, forgetPassword } from "../../redux/actions";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa6";
import pointLogo from "../../assets/the-point-logo.png"
import { MdOutlineLock, MdOutlineMail } from "react-icons/md";

const Changepassword = ({ close }) => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const checkRef = useRef();

  const handleForgetPassword = async () => {
    try {
      setLoading(true);
      let finalPayload = { email };
      let data = await forgetPassword(finalPayload);
      if (!data.success) throw new Error(data?.message);
      toast.success(data?.message);
      close(false);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
      <div className="w-96 h-96 bg-white flex flex-col items-center justify-center gap-6 p-4 relative">
        <span
          className="absolute top-2.5 right-2.5 text-xl text-black cursor-pointer"
          onClick={() => close(false)}
        >
          &#x2715;
        </span>
        <div className="flex flex-col items-center justify-center gap-12 w-full">
          <h2 className="pb-2 w-full text-center text-xl">Forget Password</h2>
          <div className="text-black w-full">
            <span className="text-black text-sm font-medium">Email*</span>
            <div className="flex border border-black">
              <input
                type="text"
                value={email}
                name="email"
                className="border-none outline-none w-full"
                onChange={(e) => setEmail(e.target.value)}
                maxLength="100"
                placeholder="Enter Your Email"
                autoComplete="off"
              />
            </div>
            <span ref={checkRef} className="hidden text-xs text-red-500">
              *Username is required
            </span>
          </div>
          <button
            onClick={handleForgetPassword}
            className="outline-none p-2 border-none bg-black text-white w-full flex items-center justify-center"
          >
            {loading ? "Loading..." : "Confirm"}
          </button>
        </div>
      </div >
    </div >
  );
};

const Login = (props) => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [show, setShow] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);

  const textChangeHandler = (e) => {
    let key = e.target.name;
    let value = e.target.value;
    setFormData({ ...formData, [key]: value });
  };

  const loginValidate = (e) => {
    e.preventDefault();
    if (formData.email === "" || formData.password === "") {
      return toast.info("Please enter your credentials");
    }
    props.setLoading(true);
    let requestBody = {
      email: formData.email,
      password: formData.password,
      "deviceType": "web",
      "deviceId": `${Date.now()}`,
    };
    props
      .loginAction(requestBody)
      .then((data) => {
        if (data.success) {
          toast.success(data.message);

          const searchParams = new URLSearchParams(window.location.search);
          const redirectRoute = searchParams.get("route") || "/";

          // Ensure redirect goes to login if already at root "/"
          window.location.href = redirectRoute;

        } else {
          toast.error(data.msg || 'An error occurred'); // Fallback error message
        }
        props.setLoading(false);
      })
      .catch((err) => {
        toast.error(err.message);
        props.setLoading(false);
      });
  };

  return (
    <div className="flex relative justify-center items-center w-full h-screen">
      {showChangePassword && <Changepassword close={setShowChangePassword} />}
      <form
        onSubmit={loginValidate}
        className="text-black bg-[#fff] border rounded lg:w-[35vw] md:w-[50vw] w-[90%] md:p-8 p-4 flex flex-col md:gap-4 gap-2"
        autoComplete="off"
      >
        <div className="flex flex-col justify-center items-center gap-1 mb-4">
          <img src={pointLogo} className="h-12 rounded-md" />
          <h2 className="text-center md:text-xl text-base font-semibold ">
            Point of India
          </h2>
          <p className="text-xs">Your Ultimate Digital Informatoin Partner</p>
        </div>
        <div className="flex flex-col md:text-base text-xs justify-center gap-4">
          <div className="mb-3 space-y-2">
            <span className="text-sm">Email*</span>
            <div className="flex items-center border py-1 bg-white px-2">
              <MdOutlineMail className="text-xl text-gray-600" />
              <input
                type="email"
                required
                value={formData.email}
                name="email"
                onChange={textChangeHandler}
                maxLength="100"
                placeholder="Enter User Name"
                autoComplete="off"
                className="w-full border-none text-sm bg-transparent text-gray-600"
              />
            </div>
          </div>
          <div className="mb-3 space-y-2">
            <label className="">Password</label>
            <div className="border px-2 py-1 flex bg-white items-center">
              <MdOutlineLock className="text-xl text-gray-600" />
              <input
                type={show ? "text" : "password"}
                value={formData.password}
                name="password"
                onChange={textChangeHandler}
                maxLength="100"
                placeholder="Password"
                autoComplete="off"
                className="w-full border-none text-sm bg-transparent text-gray-600"
              />
              {show ? (
                <FaRegEye
                  className="cursor-pointer text-xl text-[#00000081]"
                  onClick={() => setShow(false)}
                />
              ) : (
                <FaRegEyeSlash
                  className="cursor-pointer text-xl text-[#00000081]"
                  onClick={() => setShow(true)}
                />
              )}
            </div>
          </div>
          <div className="w-full flex items-center justify-between my-3">
            <div className="flex items-center gap-1.5 justify-center">
              <input type="checkbox" />
              <span className="">Remember me</span>
            </div>
            <div
              onClick={() => {
                setShowChangePassword(true);
                localStorage.setItem("component", 1);
              }}
            >
              <span className="cursor-pointer">Forget Password?</span>
            </div>
          </div>
          <button
            className="w-full bg-[#dc2626] text-white p-2 rounded"
            type="submit"
          >
            {props.loading ? "Loading..." : "Login"}
          </button>
        </div>
        <div className="text-[#575454] w-full md:text-[11px] text-[9px] mt-4">
          The admin panel is for authorized POINT OF INDIA Limited users to
          manage operations. Unauthorized access is prohibited.
        </div>
      </form>
    </div>
  );
};

export default connect(null, { loginAction })(IsLoadingHOC(Login, "Please Wait....."));